import m from "../../geodata/es2015/malaysiaLow";
window.am4geodata_malaysiaLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/malaysiaLow.js
// module id = null
// module chunks = 